module.exports = __webpack_public_path__ + "static/media/success.835f78d9.svg";